export default __webpack_public_path__ + "static/B0011-3a04fa2c7d9b6ef619c1f060a41ed8f7.png";